import repositories from '..';

const resource = '/master/faculties';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
